'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _require = require('interface-datastore'),
    Key = _require.Key;

var _require2 = require('libp2p-record'),
    Record = _require2.Record;

var _require3 = require('buffer'),
    Buffer = _require3.Buffer;

var _require4 = require('./utils'),
    encodeBase32 = _require4.encodeBase32;

var errcode = require('err-code');

var debug = require('debug');

var log = debug('ipfs:ipns:offline-datastore');
log.error = debug('ipfs:ipns:offline-datastore:error'); // Offline datastore aims to mimic the same encoding as routing when storing records
// to the local datastore

var OfflineDatastore = /*#__PURE__*/function () {
  function OfflineDatastore(repo) {
    _classCallCheck(this, OfflineDatastore);

    this._repo = repo;
  }
  /**
   * Put a value to the local datastore indexed by the received key properly encoded.
   * @param {Buffer} key identifier of the value.
   * @param {Buffer} value value to be stored.
   * @param {function(Error)} callback
   * @returns {void}
   */


  _createClass(OfflineDatastore, [{
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, value) {
        var routingKey, record;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (Buffer.isBuffer(key)) {
                  _context.next = 2;
                  break;
                }

                throw errcode(new Error('Offline datastore key must be a buffer'), 'ERR_INVALID_KEY');

              case 2:
                if (Buffer.isBuffer(value)) {
                  _context.next = 4;
                  break;
                }

                throw errcode(new Error('Offline datastore value must be a buffer'), 'ERR_INVALID_VALUE');

              case 4:
                _context.prev = 4;
                routingKey = this._routingKey(key);
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](4);
                log.error(_context.t0);
                throw errcode(new Error('Not possible to generate the routing key'), 'ERR_GENERATING_ROUTING_KEY');

              case 12:
                // Marshal to libp2p record as the DHT does
                record = new Record(key, value);
                return _context.abrupt("return", this._repo.datastore.put(routingKey, record.serialize()));

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 8]]);
      }));

      function put(_x, _x2) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
    /**
     * Get a value from the local datastore indexed by the received key properly encoded.
     * @param {Buffer} key identifier of the value to be obtained.
     * @param {function(Error, Buffer)} callback
     * @returns {void}
     */

  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key) {
        var routingKey, res, record;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (Buffer.isBuffer(key)) {
                  _context2.next = 2;
                  break;
                }

                throw errcode(new Error('Offline datastore key must be a buffer'), 'ERR_INVALID_KEY');

              case 2:
                _context2.prev = 2;
                routingKey = this._routingKey(key);
                _context2.next = 10;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](2);
                log.error(_context2.t0);
                throw errcode(new Error('Not possible to generate the routing key'), 'ERR_GENERATING_ROUTING_KEY');

              case 10:
                _context2.next = 12;
                return this._repo.datastore.get(routingKey);

              case 12:
                res = _context2.sent;
                _context2.prev = 13;
                record = Record.deserialize(res);
                _context2.next = 21;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t1 = _context2["catch"](13);
                log.error(_context2.t1);
                throw _context2.t1;

              case 21:
                return _context2.abrupt("return", record.value);

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 6], [13, 17]]);
      }));

      function get(_x3) {
        return _get.apply(this, arguments);
      }

      return get;
    }() // encode key properly - base32(/ipns/{cid})

  }, {
    key: "_routingKey",
    value: function _routingKey(key) {
      return new Key('/' + encodeBase32(key), false);
    }
  }]);

  return OfflineDatastore;
}();

exports = module.exports = OfflineDatastore;